export const actionNames = {
  LOAD_PLAYBACK_VIDEOS: 'PLAYBACK:LOAD_PLAYBACK_VIDEOS',
  STAGE_PLAYBACK_VIDEOS: 'PLAYBACK:STAGE_PLAYBACK_VIDEOS',
  STAGE_PLAYBACK_VIDEOS_SUCCESS: 'PLAYBACK:STAGE_PLAYBACK_VIDEOS_SUCCESS',
  UNSTAGE_PLAYBACK_VIDEO: 'PLAYBACK:UNSTAGE_PLAYBACK_VIDEO',
  VIDEO_SELECTED_FOR_PLAYBACK: 'PLAYBACK:VIDEO_SELECTED_FOR_PLAYBACK',
  VIDEO_INFO_FETCH_SUCCESS: 'PLAYBACK:VIDEO_INFO_FETCH_SUCCESS',
  VIDEO_PLAYBACK_STARTED: 'PLAYBACK:VIDEO_PLAYBACK_STARTED',
  VIDEO_PLAYBACK_STOPPED: 'PLAYBACK:VIDEO_PLAYBACK_STOPPED',
  VIDEO_PLAYBACK_FAILED: 'PLAYBACK:VIDEO_PLAYBACK_FAILED',
  PLAYBACK_SELECTOR_CLOSED: 'PLAYBACK:PLAYBACK_SELECTOR_CLOSED',
  OPEN_PLAYBACK_SELECTOR: 'PLAYBACK:OPEN_PLAYBACK_SELECTOR',
  PAUSE_VIDEO: 'PLAYBACK:PAUSE_VIDEO',
  UNPAUSE_VIDEO: 'PLAYBACK:UNPAUSE_VIDEO',
  UPDATE_PAUSED_STATE: 'PLAYBACK:UPDATE_PAUSED_STATE',
  ENABLE_LOOPING: 'PLAYBACK:ENABLE_LOOPING',
  DISABLE_LOOPING: 'PLAYBACK:DISABLE_LOOPING',
  SEEK: 'PLAYBACK:SEEK',
  VIDEO_ENDED: 'PLAYBACK:VIDEO_ENDED',
  HEADLESS_PLAYBACK_READY: 'PLAYBACK:HEADLESS_PLAYBACK_READY',
  VIDEO_PLAYBACK_METRICS_UPDATED: 'PLAYBACK:VIDEO_PLAYBACK_METRICS_UPDATED',
}

export const loadPlaybackVideos = (liveId) => {
  return {
    type: actionNames.LOAD_PLAYBACK_VIDEOS,
    liveId,
  }
}

export const stagePlaybackVideos = (videos, added, removed) => {
  return {
    type: actionNames.STAGE_PLAYBACK_VIDEOS,
    videos,
    added,
    removed,
  }
}

export const unstagePlaybackVideo = (video) => {
  return {
    type: actionNames.UNSTAGE_PLAYBACK_VIDEO,
    video,
  }
}

export const videoSelectedForPlayback = (video) => {
  return {
    type: actionNames.VIDEO_SELECTED_FOR_PLAYBACK,
    video,
  }
}

export const playbackSelectorClosed = () => {
  return {
    type: actionNames.PLAYBACK_SELECTOR_CLOSED,
  }
}

export const openPlaybackSelector = () => {
  return {
    type: actionNames.OPEN_PLAYBACK_SELECTOR,
  }
}

export const playbackVideoEnded = () => {
  return {
    type: actionNames.VIDEO_ENDED,
  }
}

export const enableLooping = () => {
  return {
    type: actionNames.ENABLE_LOOPING,
  }
}

export const disableLooping = () => {
  return {
    type: actionNames.DISABLE_LOOPING,
  }
}

export const onSeek = (newPosition) => {
  return {
    type: actionNames.SEEK,
    newPosition,
  }
}
